/* THIS FILE IS AUTO-GENERATED – DO NOT EDIT */

import {lazy} from 'react'

import type {IconComponent} from './types'

/**
 * @public
 */
export type IconSymbol =
  | 'access-denied'
  | 'activity'
  | 'add-circle'
  | 'add-comment'
  | 'add-document'
  | 'add'
  | 'add-user'
  | 'api'
  | 'archive'
  | 'arrow-down'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-top-right'
  | 'arrow-up'
  | 'asterisk'
  | 'bar-chart'
  | 'basket'
  | 'bell'
  | 'bill'
  | 'binary-document'
  | 'block-content'
  | 'block-element'
  | 'blockquote'
  | 'bold'
  | 'bolt'
  | 'book'
  | 'bookmark-filled'
  | 'bookmark'
  | 'bottle'
  | 'bug'
  | 'bulb-filled'
  | 'bulb-outline'
  | 'calendar'
  | 'case'
  | 'chart-upward'
  | 'checkmark-circle'
  | 'checkmark'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-up'
  | 'circle'
  | 'clipboard'
  | 'clipboard-image'
  | 'clock'
  | 'close-circle'
  | 'close'
  | 'code-block'
  | 'code'
  | 'cog'
  | 'collapse'
  | 'color-wheel'
  | 'comment'
  | 'component'
  | 'compose'
  | 'compose-sparkles'
  | 'confetti'
  | 'controls'
  | 'copy'
  | 'credit-card'
  | 'crop'
  | 'cube'
  | 'dashboard'
  | 'database'
  | 'desktop'
  | 'diamond'
  | 'document'
  | 'document-pdf'
  | 'document-remove'
  | 'document-sheet'
  | 'document-text'
  | 'document-video'
  | 'document-word'
  | 'document-zip'
  | 'documents'
  | 'dot'
  | 'double-chevron-down'
  | 'double-chevron-left'
  | 'double-chevron-right'
  | 'double-chevron-up'
  | 'double-quote'
  | 'download'
  | 'drag-handle'
  | 'drop'
  | 'earth-americas'
  | 'earth-globe'
  | 'edit'
  | 'ellipsis-horizontal'
  | 'ellipsis-vertical'
  | 'empty'
  | 'enter'
  | 'enter-right'
  | 'envelope'
  | 'equal'
  | 'error-filled'
  | 'error-outline'
  | 'error-screen'
  | 'expand'
  | 'eye-closed'
  | 'eye-open'
  | 'face-happy'
  | 'face-indifferent'
  | 'face-sad'
  | 'feedback'
  | 'filter'
  | 'folder'
  | 'generate'
  | 'github'
  | 'groq'
  | 'hash'
  | 'heart-filled'
  | 'heart'
  | 'help-circle'
  | 'highlight'
  | 'home'
  | 'ice-cream'
  | 'image'
  | 'image-remove'
  | 'images'
  | 'inbox'
  | 'info-filled'
  | 'info-outline'
  | 'inline-element'
  | 'inline'
  | 'insert-above'
  | 'insert-below'
  | 'italic'
  | 'joystick'
  | 'json'
  | 'launch'
  | 'leave'
  | 'lemon'
  | 'link'
  | 'link-removed'
  | 'linkedin'
  | 'list'
  | 'lock'
  | 'logo-js'
  | 'logo-ts'
  | 'marker'
  | 'marker-removed'
  | 'master-detail'
  | 'menu'
  | 'microphone'
  | 'microphone-slash'
  | 'mobile-device'
  | 'moon'
  | 'number'
  | 'ok-hand'
  | 'olist'
  | 'overage'
  | 'package'
  | 'panel-left'
  | 'panel-right'
  | 'pause'
  | 'pin-filled'
  | 'pin'
  | 'pin-removed'
  | 'play'
  | 'plug'
  | 'presentation'
  | 'progress-50'
  | 'progress-75'
  | 'projects'
  | 'publish'
  | 'read-only'
  | 'redo'
  | 'refresh'
  | 'remove-circle'
  | 'remove'
  | 'reset'
  | 'restore'
  | 'retrieve'
  | 'retry'
  | 'revert'
  | 'robot'
  | 'rocket'
  | 'schema'
  | 'search'
  | 'select'
  | 'share'
  | 'sort'
  | 'sparkle'
  | 'sparkles'
  | 'spinner'
  | 'split-horizontal'
  | 'split-vertical'
  | 'square'
  | 'stack-compact'
  | 'stack'
  | 'star-filled'
  | 'star'
  | 'stop'
  | 'strikethrough'
  | 'string'
  | 'sun'
  | 'sync'
  | 'tablet-device'
  | 'tag'
  | 'tags'
  | 'target'
  | 'task'
  | 'terminal'
  | 'text'
  | 'th-large'
  | 'th-list'
  | 'thumbs-down'
  | 'thumbs-up'
  | 'tiers'
  | 'timeline'
  | 'toggle-arrow-right'
  | 'token'
  | 'transfer'
  | 'translate'
  | 'trash'
  | 'trend-upward'
  | 'triangle-outline'
  | 'trolley'
  | 'truncate'
  | 'twitter'
  | 'ulist'
  | 'unarchive'
  | 'underline'
  | 'undo'
  | 'unknown'
  | 'unlink'
  | 'unlock'
  | 'unpublish'
  | 'upload'
  | 'user'
  | 'users'
  | 'versions'
  | 'video'
  | 'warning-filled'
  | 'warning-outline'
  | 'wrench'

/**
 * @public
 */
export interface IconMap {
  'access-denied': IconComponent
  'activity': IconComponent
  'add-circle': IconComponent
  'add-comment': IconComponent
  'add-document': IconComponent
  'add': IconComponent
  'add-user': IconComponent
  'api': IconComponent
  'archive': IconComponent
  'arrow-down': IconComponent
  'arrow-left': IconComponent
  'arrow-right': IconComponent
  'arrow-top-right': IconComponent
  'arrow-up': IconComponent
  'asterisk': IconComponent
  'bar-chart': IconComponent
  'basket': IconComponent
  'bell': IconComponent
  'bill': IconComponent
  'binary-document': IconComponent
  'block-content': IconComponent
  'block-element': IconComponent
  'blockquote': IconComponent
  'bold': IconComponent
  'bolt': IconComponent
  'book': IconComponent
  'bookmark-filled': IconComponent
  'bookmark': IconComponent
  'bottle': IconComponent
  'bug': IconComponent
  'bulb-filled': IconComponent
  'bulb-outline': IconComponent
  'calendar': IconComponent
  'case': IconComponent
  'chart-upward': IconComponent
  'checkmark-circle': IconComponent
  'checkmark': IconComponent
  'chevron-down': IconComponent
  'chevron-left': IconComponent
  'chevron-right': IconComponent
  'chevron-up': IconComponent
  'circle': IconComponent
  'clipboard': IconComponent
  'clipboard-image': IconComponent
  'clock': IconComponent
  'close-circle': IconComponent
  'close': IconComponent
  'code-block': IconComponent
  'code': IconComponent
  'cog': IconComponent
  'collapse': IconComponent
  'color-wheel': IconComponent
  'comment': IconComponent
  'component': IconComponent
  'compose': IconComponent
  'compose-sparkles': IconComponent
  'confetti': IconComponent
  'controls': IconComponent
  'copy': IconComponent
  'credit-card': IconComponent
  'crop': IconComponent
  'cube': IconComponent
  'dashboard': IconComponent
  'database': IconComponent
  'desktop': IconComponent
  'diamond': IconComponent
  'document': IconComponent
  'document-pdf': IconComponent
  'document-remove': IconComponent
  'document-sheet': IconComponent
  'document-text': IconComponent
  'document-video': IconComponent
  'document-word': IconComponent
  'document-zip': IconComponent
  'documents': IconComponent
  'dot': IconComponent
  'double-chevron-down': IconComponent
  'double-chevron-left': IconComponent
  'double-chevron-right': IconComponent
  'double-chevron-up': IconComponent
  'double-quote': IconComponent
  'download': IconComponent
  'drag-handle': IconComponent
  'drop': IconComponent
  'earth-americas': IconComponent
  'earth-globe': IconComponent
  'edit': IconComponent
  'ellipsis-horizontal': IconComponent
  'ellipsis-vertical': IconComponent
  'empty': IconComponent
  'enter': IconComponent
  'enter-right': IconComponent
  'envelope': IconComponent
  'equal': IconComponent
  'error-filled': IconComponent
  'error-outline': IconComponent
  'error-screen': IconComponent
  'expand': IconComponent
  'eye-closed': IconComponent
  'eye-open': IconComponent
  'face-happy': IconComponent
  'face-indifferent': IconComponent
  'face-sad': IconComponent
  'feedback': IconComponent
  'filter': IconComponent
  'folder': IconComponent
  'generate': IconComponent
  'github': IconComponent
  'groq': IconComponent
  'hash': IconComponent
  'heart-filled': IconComponent
  'heart': IconComponent
  'help-circle': IconComponent
  'highlight': IconComponent
  'home': IconComponent
  'ice-cream': IconComponent
  'image': IconComponent
  'image-remove': IconComponent
  'images': IconComponent
  'inbox': IconComponent
  'info-filled': IconComponent
  'info-outline': IconComponent
  'inline-element': IconComponent
  'inline': IconComponent
  'insert-above': IconComponent
  'insert-below': IconComponent
  'italic': IconComponent
  'joystick': IconComponent
  'json': IconComponent
  'launch': IconComponent
  'leave': IconComponent
  'lemon': IconComponent
  'link': IconComponent
  'link-removed': IconComponent
  'linkedin': IconComponent
  'list': IconComponent
  'lock': IconComponent
  'logo-js': IconComponent
  'logo-ts': IconComponent
  'marker': IconComponent
  'marker-removed': IconComponent
  'master-detail': IconComponent
  'menu': IconComponent
  'microphone': IconComponent
  'microphone-slash': IconComponent
  'mobile-device': IconComponent
  'moon': IconComponent
  'number': IconComponent
  'ok-hand': IconComponent
  'olist': IconComponent
  'overage': IconComponent
  'package': IconComponent
  'panel-left': IconComponent
  'panel-right': IconComponent
  'pause': IconComponent
  'pin-filled': IconComponent
  'pin': IconComponent
  'pin-removed': IconComponent
  'play': IconComponent
  'plug': IconComponent
  'presentation': IconComponent
  'progress-50': IconComponent
  'progress-75': IconComponent
  'projects': IconComponent
  'publish': IconComponent
  'read-only': IconComponent
  'redo': IconComponent
  'refresh': IconComponent
  'remove-circle': IconComponent
  'remove': IconComponent
  'reset': IconComponent
  'restore': IconComponent
  'retrieve': IconComponent
  'retry': IconComponent
  'revert': IconComponent
  'robot': IconComponent
  'rocket': IconComponent
  'schema': IconComponent
  'search': IconComponent
  'select': IconComponent
  'share': IconComponent
  'sort': IconComponent
  'sparkle': IconComponent
  'sparkles': IconComponent
  'spinner': IconComponent
  'split-horizontal': IconComponent
  'split-vertical': IconComponent
  'square': IconComponent
  'stack-compact': IconComponent
  'stack': IconComponent
  'star-filled': IconComponent
  'star': IconComponent
  'stop': IconComponent
  'strikethrough': IconComponent
  'string': IconComponent
  'sun': IconComponent
  'sync': IconComponent
  'tablet-device': IconComponent
  'tag': IconComponent
  'tags': IconComponent
  'target': IconComponent
  'task': IconComponent
  'terminal': IconComponent
  'text': IconComponent
  'th-large': IconComponent
  'th-list': IconComponent
  'thumbs-down': IconComponent
  'thumbs-up': IconComponent
  'tiers': IconComponent
  'timeline': IconComponent
  'toggle-arrow-right': IconComponent
  'token': IconComponent
  'transfer': IconComponent
  'translate': IconComponent
  'trash': IconComponent
  'trend-upward': IconComponent
  'triangle-outline': IconComponent
  'trolley': IconComponent
  'truncate': IconComponent
  'twitter': IconComponent
  'ulist': IconComponent
  'unarchive': IconComponent
  'underline': IconComponent
  'undo': IconComponent
  'unknown': IconComponent
  'unlink': IconComponent
  'unlock': IconComponent
  'unpublish': IconComponent
  'upload': IconComponent
  'user': IconComponent
  'users': IconComponent
  'versions': IconComponent
  'video': IconComponent
  'warning-filled': IconComponent
  'warning-outline': IconComponent
  'wrench': IconComponent
}

/**
 * @public
 */
export const icons: IconMap = {
  'access-denied': lazy(() => import('./exports/AccessDenied')),
  'activity': lazy(() => import('./exports/Activity')),
  'add-circle': lazy(() => import('./exports/AddCircle')),
  'add-comment': lazy(() => import('./exports/AddComment')),
  'add-document': lazy(() => import('./exports/AddDocument')),
  'add': lazy(() => import('./exports/Add')),
  'add-user': lazy(() => import('./exports/AddUser')),
  'api': lazy(() => import('./exports/Api')),
  'archive': lazy(() => import('./exports/Archive')),
  'arrow-down': lazy(() => import('./exports/ArrowDown')),
  'arrow-left': lazy(() => import('./exports/ArrowLeft')),
  'arrow-right': lazy(() => import('./exports/ArrowRight')),
  'arrow-top-right': lazy(() => import('./exports/ArrowTopRight')),
  'arrow-up': lazy(() => import('./exports/ArrowUp')),
  'asterisk': lazy(() => import('./exports/Asterisk')),
  'bar-chart': lazy(() => import('./exports/BarChart')),
  'basket': lazy(() => import('./exports/Basket')),
  'bell': lazy(() => import('./exports/Bell')),
  'bill': lazy(() => import('./exports/Bill')),
  'binary-document': lazy(() => import('./exports/BinaryDocument')),
  'block-content': lazy(() => import('./exports/BlockContent')),
  'block-element': lazy(() => import('./exports/BlockElement')),
  'blockquote': lazy(() => import('./exports/Blockquote')),
  'bold': lazy(() => import('./exports/Bold')),
  'bolt': lazy(() => import('./exports/Bolt')),
  'book': lazy(() => import('./exports/Book')),
  'bookmark-filled': lazy(() => import('./exports/BookmarkFilled')),
  'bookmark': lazy(() => import('./exports/Bookmark')),
  'bottle': lazy(() => import('./exports/Bottle')),
  'bug': lazy(() => import('./exports/Bug')),
  'bulb-filled': lazy(() => import('./exports/BulbFilled')),
  'bulb-outline': lazy(() => import('./exports/BulbOutline')),
  'calendar': lazy(() => import('./exports/Calendar')),
  'case': lazy(() => import('./exports/Case')),
  'chart-upward': lazy(() => import('./exports/ChartUpward')),
  'checkmark-circle': lazy(() => import('./exports/CheckmarkCircle')),
  'checkmark': lazy(() => import('./exports/Checkmark')),
  'chevron-down': lazy(() => import('./exports/ChevronDown')),
  'chevron-left': lazy(() => import('./exports/ChevronLeft')),
  'chevron-right': lazy(() => import('./exports/ChevronRight')),
  'chevron-up': lazy(() => import('./exports/ChevronUp')),
  'circle': lazy(() => import('./exports/Circle')),
  'clipboard': lazy(() => import('./exports/Clipboard')),
  'clipboard-image': lazy(() => import('./exports/ClipboardImage')),
  'clock': lazy(() => import('./exports/Clock')),
  'close-circle': lazy(() => import('./exports/CloseCircle')),
  'close': lazy(() => import('./exports/Close')),
  'code-block': lazy(() => import('./exports/CodeBlock')),
  'code': lazy(() => import('./exports/Code')),
  'cog': lazy(() => import('./exports/Cog')),
  'collapse': lazy(() => import('./exports/Collapse')),
  'color-wheel': lazy(() => import('./exports/ColorWheel')),
  'comment': lazy(() => import('./exports/Comment')),
  'component': lazy(() => import('./exports/Component')),
  'compose': lazy(() => import('./exports/Compose')),
  'compose-sparkles': lazy(() => import('./exports/ComposeSparkles')),
  'confetti': lazy(() => import('./exports/Confetti')),
  'controls': lazy(() => import('./exports/Controls')),
  'copy': lazy(() => import('./exports/Copy')),
  'credit-card': lazy(() => import('./exports/CreditCard')),
  'crop': lazy(() => import('./exports/Crop')),
  'cube': lazy(() => import('./exports/Cube')),
  'dashboard': lazy(() => import('./exports/Dashboard')),
  'database': lazy(() => import('./exports/Database')),
  'desktop': lazy(() => import('./exports/Desktop')),
  'diamond': lazy(() => import('./exports/Diamond')),
  'document': lazy(() => import('./exports/Document')),
  'document-pdf': lazy(() => import('./exports/DocumentPdf')),
  'document-remove': lazy(() => import('./exports/DocumentRemove')),
  'document-sheet': lazy(() => import('./exports/DocumentSheet')),
  'document-text': lazy(() => import('./exports/DocumentText')),
  'document-video': lazy(() => import('./exports/DocumentVideo')),
  'document-word': lazy(() => import('./exports/DocumentWord')),
  'document-zip': lazy(() => import('./exports/DocumentZip')),
  'documents': lazy(() => import('./exports/Documents')),
  'dot': lazy(() => import('./exports/Dot')),
  'double-chevron-down': lazy(() => import('./exports/DoubleChevronDown')),
  'double-chevron-left': lazy(() => import('./exports/DoubleChevronLeft')),
  'double-chevron-right': lazy(() => import('./exports/DoubleChevronRight')),
  'double-chevron-up': lazy(() => import('./exports/DoubleChevronUp')),
  'double-quote': lazy(() => import('./exports/DoubleQuote')),
  'download': lazy(() => import('./exports/Download')),
  'drag-handle': lazy(() => import('./exports/DragHandle')),
  'drop': lazy(() => import('./exports/Drop')),
  'earth-americas': lazy(() => import('./exports/EarthAmericas')),
  'earth-globe': lazy(() => import('./exports/EarthGlobe')),
  'edit': lazy(() => import('./exports/Edit')),
  'ellipsis-horizontal': lazy(() => import('./exports/EllipsisHorizontal')),
  'ellipsis-vertical': lazy(() => import('./exports/EllipsisVertical')),
  'empty': lazy(() => import('./exports/Empty')),
  'enter': lazy(() => import('./exports/Enter')),
  'enter-right': lazy(() => import('./exports/EnterRight')),
  'envelope': lazy(() => import('./exports/Envelope')),
  'equal': lazy(() => import('./exports/Equal')),
  'error-filled': lazy(() => import('./exports/ErrorFilled')),
  'error-outline': lazy(() => import('./exports/ErrorOutline')),
  'error-screen': lazy(() => import('./exports/ErrorScreen')),
  'expand': lazy(() => import('./exports/Expand')),
  'eye-closed': lazy(() => import('./exports/EyeClosed')),
  'eye-open': lazy(() => import('./exports/EyeOpen')),
  'face-happy': lazy(() => import('./exports/FaceHappy')),
  'face-indifferent': lazy(() => import('./exports/FaceIndifferent')),
  'face-sad': lazy(() => import('./exports/FaceSad')),
  'feedback': lazy(() => import('./exports/Feedback')),
  'filter': lazy(() => import('./exports/Filter')),
  'folder': lazy(() => import('./exports/Folder')),
  'generate': lazy(() => import('./exports/Generate')),
  'github': lazy(() => import('./exports/Github')),
  'groq': lazy(() => import('./exports/Groq')),
  'hash': lazy(() => import('./exports/Hash')),
  'heart-filled': lazy(() => import('./exports/HeartFilled')),
  'heart': lazy(() => import('./exports/Heart')),
  'help-circle': lazy(() => import('./exports/HelpCircle')),
  'highlight': lazy(() => import('./exports/Highlight')),
  'home': lazy(() => import('./exports/Home')),
  'ice-cream': lazy(() => import('./exports/IceCream')),
  'image': lazy(() => import('./exports/Image')),
  'image-remove': lazy(() => import('./exports/ImageRemove')),
  'images': lazy(() => import('./exports/Images')),
  'inbox': lazy(() => import('./exports/Inbox')),
  'info-filled': lazy(() => import('./exports/InfoFilled')),
  'info-outline': lazy(() => import('./exports/InfoOutline')),
  'inline-element': lazy(() => import('./exports/InlineElement')),
  'inline': lazy(() => import('./exports/Inline')),
  'insert-above': lazy(() => import('./exports/InsertAbove')),
  'insert-below': lazy(() => import('./exports/InsertBelow')),
  'italic': lazy(() => import('./exports/Italic')),
  'joystick': lazy(() => import('./exports/Joystick')),
  'json': lazy(() => import('./exports/Json')),
  'launch': lazy(() => import('./exports/Launch')),
  'leave': lazy(() => import('./exports/Leave')),
  'lemon': lazy(() => import('./exports/Lemon')),
  'link': lazy(() => import('./exports/Link')),
  'link-removed': lazy(() => import('./exports/LinkRemoved')),
  'linkedin': lazy(() => import('./exports/Linkedin')),
  'list': lazy(() => import('./exports/List')),
  'lock': lazy(() => import('./exports/Lock')),
  'logo-js': lazy(() => import('./exports/LogoJs')),
  'logo-ts': lazy(() => import('./exports/LogoTs')),
  'marker': lazy(() => import('./exports/Marker')),
  'marker-removed': lazy(() => import('./exports/MarkerRemoved')),
  'master-detail': lazy(() => import('./exports/MasterDetail')),
  'menu': lazy(() => import('./exports/Menu')),
  'microphone': lazy(() => import('./exports/Microphone')),
  'microphone-slash': lazy(() => import('./exports/MicrophoneSlash')),
  'mobile-device': lazy(() => import('./exports/MobileDevice')),
  'moon': lazy(() => import('./exports/Moon')),
  'number': lazy(() => import('./exports/Number')),
  'ok-hand': lazy(() => import('./exports/OkHand')),
  'olist': lazy(() => import('./exports/Olist')),
  'overage': lazy(() => import('./exports/Overage')),
  'package': lazy(() => import('./exports/Package')),
  'panel-left': lazy(() => import('./exports/PanelLeft')),
  'panel-right': lazy(() => import('./exports/PanelRight')),
  'pause': lazy(() => import('./exports/Pause')),
  'pin-filled': lazy(() => import('./exports/PinFilled')),
  'pin': lazy(() => import('./exports/Pin')),
  'pin-removed': lazy(() => import('./exports/PinRemoved')),
  'play': lazy(() => import('./exports/Play')),
  'plug': lazy(() => import('./exports/Plug')),
  'presentation': lazy(() => import('./exports/Presentation')),
  'progress-50': lazy(() => import('./exports/Progress50')),
  'progress-75': lazy(() => import('./exports/Progress75')),
  'projects': lazy(() => import('./exports/Projects')),
  'publish': lazy(() => import('./exports/Publish')),
  'read-only': lazy(() => import('./exports/ReadOnly')),
  'redo': lazy(() => import('./exports/Redo')),
  'refresh': lazy(() => import('./exports/Refresh')),
  'remove-circle': lazy(() => import('./exports/RemoveCircle')),
  'remove': lazy(() => import('./exports/Remove')),
  'reset': lazy(() => import('./exports/Reset')),
  'restore': lazy(() => import('./exports/Restore')),
  'retrieve': lazy(() => import('./exports/Retrieve')),
  'retry': lazy(() => import('./exports/Retry')),
  'revert': lazy(() => import('./exports/Revert')),
  'robot': lazy(() => import('./exports/Robot')),
  'rocket': lazy(() => import('./exports/Rocket')),
  'schema': lazy(() => import('./exports/Schema')),
  'search': lazy(() => import('./exports/Search')),
  'select': lazy(() => import('./exports/Select')),
  'share': lazy(() => import('./exports/Share')),
  'sort': lazy(() => import('./exports/Sort')),
  'sparkle': lazy(() => import('./exports/Sparkle')),
  'sparkles': lazy(() => import('./exports/Sparkles')),
  'spinner': lazy(() => import('./exports/Spinner')),
  'split-horizontal': lazy(() => import('./exports/SplitHorizontal')),
  'split-vertical': lazy(() => import('./exports/SplitVertical')),
  'square': lazy(() => import('./exports/Square')),
  'stack-compact': lazy(() => import('./exports/StackCompact')),
  'stack': lazy(() => import('./exports/Stack')),
  'star-filled': lazy(() => import('./exports/StarFilled')),
  'star': lazy(() => import('./exports/Star')),
  'stop': lazy(() => import('./exports/Stop')),
  'strikethrough': lazy(() => import('./exports/Strikethrough')),
  'string': lazy(() => import('./exports/String')),
  'sun': lazy(() => import('./exports/Sun')),
  'sync': lazy(() => import('./exports/Sync')),
  'tablet-device': lazy(() => import('./exports/TabletDevice')),
  'tag': lazy(() => import('./exports/Tag')),
  'tags': lazy(() => import('./exports/Tags')),
  'target': lazy(() => import('./exports/Target')),
  'task': lazy(() => import('./exports/Task')),
  'terminal': lazy(() => import('./exports/Terminal')),
  'text': lazy(() => import('./exports/Text')),
  'th-large': lazy(() => import('./exports/ThLarge')),
  'th-list': lazy(() => import('./exports/ThList')),
  'thumbs-down': lazy(() => import('./exports/ThumbsDown')),
  'thumbs-up': lazy(() => import('./exports/ThumbsUp')),
  'tiers': lazy(() => import('./exports/Tiers')),
  'timeline': lazy(() => import('./exports/Timeline')),
  'toggle-arrow-right': lazy(() => import('./exports/ToggleArrowRight')),
  'token': lazy(() => import('./exports/Token')),
  'transfer': lazy(() => import('./exports/Transfer')),
  'translate': lazy(() => import('./exports/Translate')),
  'trash': lazy(() => import('./exports/Trash')),
  'trend-upward': lazy(() => import('./exports/TrendUpward')),
  'triangle-outline': lazy(() => import('./exports/TriangleOutline')),
  'trolley': lazy(() => import('./exports/Trolley')),
  'truncate': lazy(() => import('./exports/Truncate')),
  'twitter': lazy(() => import('./exports/Twitter')),
  'ulist': lazy(() => import('./exports/Ulist')),
  'unarchive': lazy(() => import('./exports/Unarchive')),
  'underline': lazy(() => import('./exports/Underline')),
  'undo': lazy(() => import('./exports/Undo')),
  'unknown': lazy(() => import('./exports/Unknown')),
  'unlink': lazy(() => import('./exports/Unlink')),
  'unlock': lazy(() => import('./exports/Unlock')),
  'unpublish': lazy(() => import('./exports/Unpublish')),
  'upload': lazy(() => import('./exports/Upload')),
  'user': lazy(() => import('./exports/User')),
  'users': lazy(() => import('./exports/Users')),
  'versions': lazy(() => import('./exports/Versions')),
  'video': lazy(() => import('./exports/Video')),
  'warning-filled': lazy(() => import('./exports/WarningFilled')),
  'warning-outline': lazy(() => import('./exports/WarningOutline')),
  'wrench': lazy(() => import('./exports/Wrench')),
}
